/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Fragment, ForwardedRef, forwardRef, useEffect, useRef } from 'react'
import { Checkbox } from '@mui/material'

export const CHECKBOX_WIDTH = 32
const IndeterminateCheckbox = forwardRef(
  ({ indeterminate, ...restOfProps }: HTMLInputElement, ref: ForwardedRef<HTMLInputElement>) => {
    const resolvedRef = useForwardedRef<HTMLInputElement>(ref)

    useEffect(() => {
      if (resolvedRef.current) {
        resolvedRef.current.indeterminate = indeterminate
      }
    }, [resolvedRef, indeterminate])

    return (
      <Fragment>
        <Checkbox
          css={css`
            width: ${CHECKBOX_WIDTH}px;
            height: ${CHECKBOX_WIDTH}px;
          `}
          //@ts-ignore
          ref={resolvedRef}
          {...restOfProps}
          indeterminate={indeterminate}
        />
      </Fragment>
    )
  }
)

export default IndeterminateCheckbox

function useForwardedRef<T>(ref: ForwardedRef<T>) {
  const innerRef = useRef<T | null>(null)

  useEffect(() => {
    if (!ref) return
    if (typeof ref === 'function') {
      ref(innerRef.current)
    } else {
      ref.current = innerRef.current
    }
  }, [])

  return innerRef
}
